module.exports = __webpack_public_path__ + "img/acbae75.png";